import { render, staticRenderFns } from "./create-footprint-product-action.vue?vue&type=template&id=74bf3fb2"
import script from "./create-footprint-product-action.ts?vue&type=script&lang=js&external"
export * from "./create-footprint-product-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports